import { AppFormItem, AppFormItemProps, AppInput } from 'components/atoms';
import { formFields } from 'consts/form/formFields';
import { max300LengthRule } from 'consts/rules/textRules';

export const AllergensInputElement = (props: AppFormItemProps) => (
    <AppFormItem
        label="Alergeny"
        name={formFields.allergens}
        rules={[max300LengthRule]}
        accessibilityLabel="Pole alergeny"
        {...props}
    >
        <AppInput
            autoComplete="off"
            accessibilityLabel="Pole alergeny"
            placeholder="Podaj alergeny"
        />
    </AppFormItem>
);
